import axiosReq from "../services/axios/index.js";
import { getApiToken, getApiUrl } from "../zustand/userState/userState.selector.js";
import { useUserState } from "../zustand/userState/userState.store.js";
import { AkatsukiClient } from "./useInitApiClients/clients/akatsuki/types.js";
import { BouncerClient } from "./useInitApiClients/clients/bouncer/types.js";
import { BridgePalpatineClient } from "./useInitApiClients/clients/bridgePalpatine/types.js";
import { CoachNicoClient } from "./useInitApiClients/clients/coach_nico/types.js";
import { CryptoClient } from "./useInitApiClients/clients/crypto/types.js";
import { EnutrofClient } from "./useInitApiClients/clients/enutrof/types.js";
import { FelindraClient } from "./useInitApiClients/clients/felindra/types.js";
import { HawkingClient } from "./useInitApiClients/clients/hawking/types.js";
import { HermesClient } from "./useInitApiClients/clients/hermes/types.js";
import { JanusClient } from "./useInitApiClients/clients/janus/types.js";
import { PictochatClient } from "./useInitApiClients/clients/pictochat/types.js";
import { ProfesorClient } from "./useInitApiClients/clients/profesor/types.js";
import { ShivaClient } from "./useInitApiClients/clients/shiva/types.js";
import { StargateClient } from "./useInitApiClients/clients/stargate/types.js";
import { VoltaireClient } from "./useInitApiClients/clients/voltaire/types.js";
import { WizzClient } from "./useInitApiClients/clients/wizz/types.js";
import { ZileanClient } from "./useInitApiClients/clients/zilean/types.js";
import { useApiClients } from "./useInitApiClients/context.js";

const requests = { ...axiosReq };

export type RequestTypes = {
    [P in keyof typeof requests]: ReturnType<(typeof requests)[P]>;
} & BouncerClient &
    EnutrofClient &
    HawkingClient &
    JanusClient &
    StargateClient &
    VoltaireClient &
    WizzClient &
    ZileanClient &
    ProfesorClient &
    ShivaClient &
    CoachNicoClient &
    HermesClient &
    PictochatClient &
    AkatsukiClient &
    CryptoClient &
    BridgePalpatineClient &
    FelindraClient;

const removeTrailingSlash = (url: string) => {
    return url.replace(/\/$/, "");
};

export default function useRequest<T extends keyof RequestTypes>(request: T): RequestTypes[T] {
    const apiUrl = useUserState(getApiUrl);
    const apiToken = useUserState(getApiToken);

    const { clients } = useApiClients();

    const clientMethod = clients.reduce<RequestTypes[T] | undefined>((res, client) => {
        if (client !== undefined && request in client) return client[request as keyof RequestTypes];
        return res;
    }, undefined);
    if (clientMethod !== undefined) return clientMethod;
    return requests?.[request as keyof RequestTypes]?.(removeTrailingSlash(apiUrl), apiToken) as RequestTypes[T];
}
